import UAParser from 'ua-parser-js'

export const getUserAgentDetails = () => {
  const unknownString = 'unknown'
  const uaParser = new UAParser(navigator.userAgent || navigator.vendor)
  const userAgentDetails = uaParser.getResult() || {}
  if (userAgentDetails.device?.type === undefined) {
    userAgentDetails.device = {
      model: unknownString,
      type: 'desktop',
      vendor: unknownString
    }
  }
  if (['console', 'smarttv', 'wearable', 'embedded'].includes(userAgentDetails.device.type)) {
    userAgentDetails.device.type = 'other'
  }
  if (userAgentDetails.cpu?.architecture === undefined) {
    userAgentDetails.cpu = { architecture: unknownString }
  }
  if (userAgentDetails.os?.name === undefined) {
    userAgentDetails.os = { name: unknownString, version: unknownString }
  }
  return userAgentDetails
}
